enum AllocationType {
  Margin = "Collateral",
  PremiumPaid = "Premium Paid",
  FeesPaid = "Fees Paid",
  Settlement = "Settlement",
  External = "External",
  Payment = "Payment",
  PremiumSent = "Premium Sent",
  SettlementReceived = "Settlement Received",
  PaymentSent = "Payment Sent",
  PaymentReceived = "Payment Received",
}

enum TransferType {
  Crypto = "Crypto",
  Fiat = "Fiat",
}

enum TransferStatus {
  Completed = "Completed",
  Pending = "Pending",
  Canceled = "Canceled",
}

export { AllocationType, TransferStatus, TransferType };
